module.exports = function getResource(label, vars = []) {
    const resources = {
        resumeSubscription: 'Resume Subscription',
        qty: 'Qty',
        deliveryEvery: 'Delivery Every',
        shippingAddress: 'Shipping Address',
        paymentMethod: 'Payment Method',
        nextShipment: 'Next Shipment by',
        item: 'ITEM',
        resume: 'Resume',
        cancel: 'Cancel',
        editMessage: 'You can make edits to your subscription after you’ve resumed shipments.',
        paymentMessage: 'By enrolling your card will be charged using your default payment method on file.',
        notRated: 'Not rated',
        oneReview: '1 review',
        yearlySavings: 'yearly savings'
    };

    return resources[label];
};
